
$(function() {
  limitedModal();
});

$( window ).on( 'load', function(){
  
});

function limitedModal() {
  var modalBtn = $('[data-limited-toggle="modal"]');
  var modalClose = $('[data-limited-close="modal"]');

  modalBtn.on('click', function(){
    var targetId = $(this).data('limited-target');
    var target = $(targetId);
    target.addClass('is-show');
    $('body').addClass('is-limited-modal-active');
    modalSlider(targetId);
  });

  // 閉じる
  modalClose.on('click', function(){
    $('.limited-item-modal').removeClass('is-show');
    $('body').removeClass('is-limited-modal-active');
  });
  $(document).on('click', function(e) {
    if($('body').hasClass('is-limited-modal-active')){
      if(!$(e.target).closest('.limited-item-modal-box,a[data-limited-toggle="modal"]').length) {
        //ここに外側をクリックしたときの処理
        $('.limited-item-modal').removeClass('is-show');
        $('body').removeClass('is-limited-modal-active');
      } else {
        //ここに内側をクリックしたときの処理
      }
    }
  });
}

/*
 * モーダル内の商品スライダー
 */
function modalSlider(targetId){
  const modalTarget = targetId;
  const sliderTargetId = targetId + '-slider';
  const thumb = document.querySelectorAll(modalTarget + ' .lm-thumb');
  const infoData = document.querySelectorAll(modalTarget + ' .lm-spec-panel');

  const switchThumb = (index) => {
    document.querySelector(modalTarget + ' .is-active').classList.remove('is-active');
    $(modalTarget + ' .lm-spec-panel').removeClass('is-active');
    thumb[index].classList.add('is-active');
    infoData[index].classList.add('is-active');
  }

  const mvSwiper = new Swiper(sliderTargetId, {
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
      nextEl: '.lm-image-slider .swiper-button-next',
      prevEl: '.lm-image-slider .swiper-button-prev',
    },
    on: {
      afterInit: (swiper) => {
        thumb[swiper.realIndex].classList.add('is-active');
        for (let i = 0; i < thumb.length; i++) {
          thumb[i].onclick = () => {
            swiper.slideTo(i);
          };
        }
      },
      slideChange: (swiper) => {
        switchThumb(swiper.realIndex);
      },
    }
  });

  //スライダー実行後にコンテンツ表示
//  $( '.feature-recommend-mv-container' ).removeClass( 'hidden' );
}
